import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService, SuccessResponse } from '@sheerid/jslib';
import { CopyToClipboard } from '../CopyToClipboard/CopyToClipboardComponent';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    window.open(redirectDestination, '_parent');
};

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    const redirectDestination = 'https://www.tuftandneedle.com/products/'; // verificationService.programTheme.intl.messages.step.success.redirectUrl;

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="You are verified!" />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="You can use your code now or later. Look for the email from verify@sheerid.com for a copy of this code. <br><br> Here's your one-time use promo code:"/>
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>
            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage="Now that you've been approved, please direct all questions about the promotion terms and/or code use to Tuft &amp; Needle."/>
            </div>


            {((verificationService.viewModel.metadata ? verificationService.viewModel.metadata['redirectUrl'] : undefined) === 'true') ?
                <div className="sid-submit sid-l-space-top-md">
                    <button
                        onClick={() => redirect(redirectDestination)}
                        className="sid-btn sid-btn--dark"
                    >
                        <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Continue" />
                    </button>
                </div>
            :
                null
            }

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage="
                    Now that you've been approved, please direct all questions about the promotion terms and/or code use to Tuft &amp; Needle."
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
